import React from 'react';
import clsx from 'clsx';
import {Icon, type IconProps, faSearch} from '@netx/core-icons';
import {composeClasses, styled} from '@netx/core-components/Theme';
import searchFilterStartAdornmentClasses, {
	getSearchFilterStartAdornmentClassesUtilityClass,
	type SearchFilterStartAdornmentClasses,
} from './searchFilterStartAdornmentClasses';

const useUtilityClasses = (ownerState: SearchFilterStartAdornmentProps) => {
	const {classes} = ownerState;
	const slots = {
		root: ['root'],
	};
	return composeClasses(
		slots,
		getSearchFilterStartAdornmentClassesUtilityClass,
		classes as typeof searchFilterStartAdornmentClasses,
	);
};

export const SearchFilterStartAdornmentRoot = styled('div', {
	name: 'SearchFilter',
	slot: 'StartAdornment',
})(({theme}) => ({
	color: theme.palette.text.secondary,
	marginRight: theme.spacing(1),
	marginTop: 1,
	pointerEvents: 'none',
	transition: 'all 0.2s ease',
}));

export interface SearchFilterStartAdornmentProps extends React.DetailedHTMLProps<
	React.HTMLAttributes<HTMLDivElement>,
	HTMLDivElement
> {
	classes?: Partial<SearchFilterStartAdornmentClasses>;
	className?: string;
	'data-testid'?: string;
	IconProps?: Partial<IconProps>;
}

export const SearchFilterStartAdornmentPrimitive = ({
	className,
	IconProps,
	...props
}: SearchFilterStartAdornmentProps) => {
	const classes = useUtilityClasses(props);
	return (
		<SearchFilterStartAdornmentRoot
			className={clsx(classes.root, className)}
			{...props}
		>
			<Icon icon={faSearch} {...IconProps} />
		</SearchFilterStartAdornmentRoot>
	);
};

export const SearchFilterStartAdornment = SearchFilterStartAdornmentPrimitive;
export default SearchFilterStartAdornment;
